module.exports = __webpack_public_path__ + "static/rl-truck-f40340a6298c6034366f0308a16356ff.png";